import { FC, useCallback, useEffect, useRef, useState } from 'react';
import { Autocomplete, Box, Button, Checkbox, CircularProgress, Tab, Tabs, TextField } from '@mui/material';
import { PieChart } from '@mui/x-charts/PieChart';
import { toPng } from 'html-to-image';
import { getRequest } from 'shared/utils/fetch-api';
import AllContractsList from 'widgets/all-contracts-list/AllContractsList';
import { useForm } from 'shared/utils/hooks/useForm';
import appStyles from 'app/providers/theme/App.module.css';
import Loader from 'shared/loader/Loader';
import styles from 'pages/statistics/Statistics.module.css';
import CustomButton from 'shared/custom-button/CustomButton';
import { CustomTabPanel } from 'shared/custom-tab-panel/custom-tab-panel';
import MedicalControlPanel from 'features/statistics/ui/MedicalControlPanel';
import ClinicPanel from 'features/statistics/ui/ClinicPanel';
import ClientPanel from 'features/statistics/ui/ClientPanel';
import { useAppDispatch, useAppSelector } from 'shared/utils/hooks/useRedux';
import { fetchCommonStatistics, fetchStatisticsClientService, fetchStatisticsMedicalDesk } from 'entities/statistics/actions/fetch-statistics';
import { selectIsLoading } from 'entities/statistics/selector';


export const Statistics: FC = () => {
    const loadingStatistics = useAppSelector(selectIsLoading);
    const dispatch = useAppDispatch();
    const { formData, handleAutocompeteChange } = useForm({
        list: ''
    });
    const [value, setValue] = useState(0);
    const a11yProps = (index: number) => {
        return {
            id: `simple-tab-${index}`,
            'aria-controls': `simple-tabpanel-${index}`,
        };
    };

    const handleChange = (event: React.SyntheticEvent, newValue: number) => {
        setValue(newValue);
    };
    const tabsRef = useRef<HTMLDivElement>(null);
    const handleWheel = (event: React.WheelEvent) => {
        if (tabsRef.current) {
            const tabsContainer = tabsRef.current.querySelector('.MuiTabs-scroller');
            if (tabsContainer) {
                tabsContainer.scrollLeft += event.deltaY * 4;
            }
        }
    };
    const [contractID, setContractID] = useState<string | string[]>('');

    useEffect(() => {
        if (contractID) {
            dispatch(fetchStatisticsMedicalDesk({ ContractID: contractID }));
            dispatch(fetchStatisticsClientService({ ContractID: contractID }));
            dispatch(fetchCommonStatistics({ ContractID: contractID }));
        }
    }, [contractID, dispatch])

    return (
        <Box>
            <Box className={appStyles.titleBox}>
                <h1>Статистика</h1>
            </Box>
            <AllContractsList
                formData={formData}
                handleAutocompeteChange={handleAutocompeteChange}
                setContractID={setContractID}
                multiple={false}
                name="list"
            />
            {loadingStatistics ? (
                <Loader
                    title='Собираем статистику. Это займет несколько секунд.'
                />
            ) : (
                <>
                    <Box onWheel={handleWheel} ref={tabsRef} className={styles.tabsBox}>
                        <Tabs
                            value={value}
                            onChange={handleChange}
                            variant="scrollable"
                            scrollButtons="auto"
                            aria-label="scrollable auto tabs example"
                            sx={{
                                '& .MuiTabs-indicator': {
                                    backgroundColor: '#0054E6'
                                },
                            }}
                        >
                            <Tab
                                label="Обращения на мед.пульт"
                                {...a11yProps(0)}
                                sx={{
                                    '&.Mui-selected': {
                                        color: '#0054E6 !important',
                                    },
                                }}
                            />
                            {/* <Tab
                                label="Обращения в разрезе клиник"
                                {...a11yProps(1)}
                                sx={{
                                    '&.Mui-selected': {
                                        color: '#0054E6 !important',
                                    },
                                }}
                            />
                            <Tab
                                label="Клиентский сервис"
                                {...a11yProps(2)}
                                sx={{
                                    '&.Mui-selected': {
                                        color: '#0054E6 !important',
                                    },
                                }}
                            /> */}

                        </Tabs>
                    </Box>
                    <CustomTabPanel value={value} index={0}>
                        <MedicalControlPanel />
                    </CustomTabPanel>
                    <CustomTabPanel value={value} index={1}>
                        <ClinicPanel />
                    </CustomTabPanel>
                    <CustomTabPanel value={value} index={2}>
                        <ClientPanel />
                    </CustomTabPanel></>
            )}

        </Box >
    );
};

export default Statistics;
